<app-modal [show]="show" (onHide)="close()"
  [title]="translationManager.getTranslation('Члан тима укључен у оцењивање понуда')">
  <div class="page-content container">
    <!-- <div class="page-header">
      <h1>
        {{ translationManager.getTranslation('Члан тима укључен у оцењивање понуда') }}
      </h1>
    </div> -->

    <div class="page-data shadow-sm">
      <!-- <div class="page-part">
        <div class="alert alert-info">
          <span *ngIf="state === viewState.Create">
            <i class="fa fa-info-circle"></i>
            {{ translationManager.getTranslation('Страница за додавање новог члана, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>
          <span *ngIf="state === viewState.Create">
            <i class="fa fa-info-circle"></i>
            {{ translationManager.getTranslation('Страница за измену постојећег члана, молимо попуните потребне податке, сачувати промене притиском на дугме "Сачувај"') }}</span>

        </div>
      </div> -->

      <div class="form-blocks">
        <div>
          <div class="content">
            <div class="form-element">

              <div class="page-part">
                <div class="form-element"
                  [ngClass]="{ 'error': form.elements['employeeId'].error.required || form.elements['employeeId'].error.invalid }">
                  <label>{{ translationManager.getTranslation('Име и презиме') }}</label>
                  <div class="content" *ngIf="!isReadonly" [ngClass]="{ 'with-action': true }">
                    <div class="static">
                      <span>{{ form.elements['employeeFullName'].value | appvalue }}</span>
                    </div>
                    <div class="action">
                      <a href="javascript:;" [title]=" translationManager.getTranslation('Селектуј запосленог')"
                        (click)="selectActiveEmployee()">
                        <i class="fa fa-search mr-2"></i>
                      </a>
                    </div>
                  </div>
                  <div class="content" *ngIf="isReadonly">
                    <div class="static">
                        <span>{{ form.elements['employeeFullName'].value | appvalue }}</span>
                    </div>
                </div>
                  <div class="errors">
                    <span *ngIf="form.elements['employeeId'].error.required">
                      <i
                        class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                  </div>
                </div>
              </div>

              <div class="page-part">
                <div class="form-element">
                  <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                  <div class="content">
                    <div class="static">
                      <span>{{ form.elements['organizationalUnit'].value | appvalue }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page-part">
                <div class="form-element">
                  <label>{{ translationManager.getTranslation('Позиција') }}</label>
                  <div class="content">
                    <div class="static">
                      <span>{{ form.elements['employeePosition'].value | appvalue }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page-part">
                <div class="form-element">
                  <label>{{ translationManager.getTranslation('Кадровска област') }}</label>
                  <div class="content">
                    <div class="static">
                      <span>{{ form.elements['personnelArea'].value | appvalue }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="page-part">
                <div class="form-element"
                  [ngClass]="{ 'error': isAssessmentAreaSelectRequired }">
                  <label>{{ translationManager.getTranslation('Област оцењивања') }}</label>
                    <p-multiSelect
                          [options]="assessmentAreas"
                          [(ngModel)]="selectedAssessmentAreaIds"
                          defaultLabel="{{ translationManager.getTranslation('Изаберите') }}"
                          optionLabel="name"
                          optionValue="id"
                      ></p-multiSelect>
                  </div>
                  <div class="errors">
                    <span *ngIf="isAssessmentAreaSelectRequired">
                      <i
                        class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
                  </div>
              </div>

              <div class="app-modal-actions">
                <button class="btn btn-success" (click)="submit()">
                  <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation("Сачувај") }}
                </button>
                <button (click)="close()" class="btn btn-warning">
                  <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation("Одустани") }}
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<users-active-employees-select #usersActiveEmployeesSelectComponent></users-active-employees-select>
